import { render, staticRenderFns } from "./ModalItemDrafting.vue?vue&type=template&id=57841b32&scoped=true&"
import script from "./ModalItemDrafting.vue?vue&type=script&lang=js&"
export * from "./ModalItemDrafting.vue?vue&type=script&lang=js&"
import style0 from "./ModalItemDrafting.vue?vue&type=style&index=0&id=57841b32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57841b32",
  null
  
)

export default component.exports